// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"0193d49e","234":"e28c946f","249":"0c6707ab","358":"5a54a4bd","870":"f49951a5"}[chunkId] + ".chunk.css";
};